import { FaqServiceSupportThemeSizeConfig } from './types';

const large: FaqServiceSupportThemeSizeConfig = {
  faqServiceSupport: {},
};

export default large;
